import React, { useState } from "react";

import { NavToggle } from "../components/NavToggle";
import { NavBrand } from "../components/NavBrand";
import { NavBack } from "../components/NavBack";
import { DesktopMenu } from "./DesktopMenu/DesktopMenu";
import "./DesktopNavbar.scss";

export const DesktopNavbar = ({ isDesktop }) => {
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);

  return (
    <>
      <nav className="navbar-root">
        <div className="container">
          <NavToggle
            onClick={() => {
              setOffcanvasOpen((prev) => !prev);
            }}
            isOffcanvasOpen={false}
          />

          <NavBack
            isOffcanvasOpen={isOffcanvasOpen}
            onClick={() => {
              window.dispatchEvent(new CustomEvent("navbar:back-click"));
            }}
          />

          <NavBrand
            isOffcanvas={false}
          />

          <DesktopMenu
            isDesktop={isDesktop}
            isOffcanvasOpen={isOffcanvasOpen}
            onClick={() => {
              setOffcanvasOpen((prev) => !prev);
            }}
          />
        </div>
      </nav>

      <div
        className={`offcanvas-backdrop ${isOffcanvasOpen ? "show" : ""}`}
        onClick={() => {
          setOffcanvasOpen((prev) => !prev);
        }}
      ></div>
    </>
  );
};
